

import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddCustomerPopup from './clients/AddCustomerPopup';
import EditCustomerPopup from './clients/EditCustomerPopup';
import CustomerTable from './clients/CustomerTable';
import Pagination from './clients/Pagination';
import { MdPersonAddAlt } from "react-icons/md";



const TotalCustomerGrid = ({ user, setView }) => {
  const [customers, setCustomers] = useState([]);
  const [totalCalls, setTotalCalls] = useState(0);
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [editCustomer, setEditCustomer] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    if (user) fetchData();
  }, [user]);

  const fetchData = async () => {
    try {
      const customersResponse = await fetch(`${process.env.REACT_APP_SERVER_API}/api/users`);
      const customersData = await customersResponse.json();
      const filteredCustomers = customersData.filter(user => user.role?.toLowerCase() !== "admin");
      setCustomers(filteredCustomers);

      const callsResponse = await fetch(`${process.env.REACT_APP_SERVER_API}/api/call-history?userId=${user.id}&role=${user.role}`);
      const callsData = await callsResponse.json();
      setCallData(callsData);
      setTotalCalls(callsData.length);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const handleAddSuccess = (newCustomer) => {
    setCustomers(prev => [...prev, newCustomer]);
    setIsAddPopupOpen(false);
    toast.success('Client added successfully!');
    fetchData();
  };

  const handleEditSuccess = (updatedCustomer) => {
    setCustomers(prev => prev.map(cust => cust._id === updatedCustomer._id ? updatedCustomer : cust));
    setIsEditPopupOpen(false);
    setEditCustomer(null);
    toast.success('Client updated successfully!');
    fetchData();
  };

  const getCustomerCalls = (customerId) => callData.filter(call => call.userId === customerId).length;

  const totalPages = Math.ceil(customers.length / itemsPerPage);
  const paginatedCustomers = customers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="flex items-center space-x-2">
          <svg className="animate-spin h-8 w-8 text-blue-500" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-16 0z" />
          </svg>
          <span className="text-lg font-medium text-gray-700">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 h-full overflow-y-scroll bg-gray-50">
      <ToastContainer />
      <div className=" mb-6 ">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-3xl font-bold text-gray-900">Client Dashboard</h2>

        </div>
        <div className="flex gap-2 items-center">
          <div className=" text-black p-3 h-21 rounded-xl shadow-lg flex flex-col items-center border transform hover:scale-105 transition-transform duration-300 w-[150px]">
            <span className="text-lg font-medium">Total Client</span>
            <p className="text-lg text-center mt-2">{customers.length}</p>
          </div>
          <div className=" text-black p-3 h-21 rounded-xl shadow-lg flex flex-col items-center border transform hover:scale-105 transition-transform duration-300 w-[150px] ">
            <span className="text-lg font-medium">Total Calls</span>
            <p className="text-lg text-center mt-2">{totalCalls}</p>
          </div>
          <button
            onClick={() => setIsAddPopupOpen(true)}
            className=" ml-auto  h-12 flex items-center gap-2 text-black font-semibold py-2 px-6 rounded-lg shadow-lg border-black border      transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-400"
          >
            <MdPersonAddAlt className="text-xl" />
            Add Client
          </button>
        </div>
      </div>

      <CustomerTable
        customers={paginatedCustomers}
        getCustomerCalls={getCustomerCalls}
        onEdit={customer => { setEditCustomer(customer); setIsEditPopupOpen(true); }}
        startIndex={(currentPage - 1) * itemsPerPage}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        totalItems={customers.length}
        itemsPerPage={itemsPerPage}
      />

      {isAddPopupOpen && <AddCustomerPopup onClose={() => setIsAddPopupOpen(false)} onSuccess={handleAddSuccess} />}
      {isEditPopupOpen && editCustomer && (
        <EditCustomerPopup
          customer={editCustomer}
          onClose={() => setIsEditPopupOpen(false)}
          onSuccess={handleEditSuccess}
        />
      )}
    </div>
  );
};

export default TotalCustomerGrid;